import { AxiosMethods, EmailCampaignsApi } from '@setvi/shared/enums';
import { axiosHelper } from '@setvi/shared/services';
import type { SendTestEmailPayload, SendTestEmailResponse } from './types';

/**
 * Mutation for sending a test email before campaign send.
 * Uses Type: 5 to send as regular email but exclude from Outbox.
 */
export const sendTestEmailMutation = () => ({
  mutationFn: (body: SendTestEmailPayload): Promise<SendTestEmailResponse> =>
    axiosHelper({
      endpoint: EmailCampaignsApi.SendTestEmail,
      method: AxiosMethods.POST,
      baseURL: process.env.ADMIN_API_BASE_URL,
      body
    })
});

export * from './types';
